import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { DEVI_FORMS, deviImageFor } from "@/lib/deviForms";
import { useSettings } from "@/context/SettingsContext";
import { Sparkles, ArrowRight } from "lucide-react";

// Shardiya Navratri 2026: Day 1 = 11 Oct .. Day 9 = 19 Oct (IST). Vijayadashami = 20 Oct.
const NAV_START = new Date("2026-10-11T00:00:00+05:30");

// Returns 1..9 during Navratri, else null (based on the viewer's local date vs IST calendar day).
function currentNavratriDay() {
  const now = new Date();
  const dayMs = 86400000;
  const diff = Math.floor((now - NAV_START) / dayMs);
  if (diff >= 0 && diff <= 8) return diff + 1;
  return null;
}

// Only renders during the nine nights (auto-links to that day's Navadurga page).
export default function TodaysDeviForm() {
  const { pick, isDeva } = useLang();
  const settings = useSettings();
  const day = currentNavratriDay();
  if (!day) return null;
  const form = DEVI_FORMS[day - 1];
  if (!form) return null;

  return (
    <section className="mx-auto max-w-7xl px-5 pt-16 md:px-8 md:pt-24" data-testid="home-todays-devi-form">
      <Link
        to={`/navratri/${form.slug}`}
        className="group grid grid-cols-1 overflow-hidden border border-[var(--gold)]/45 bg-[var(--surface)] transition-all duration-500 hover:-translate-y-0.5 hover:border-[var(--gold)] hover:shadow-[0_16px_50px_rgba(199,80,0,0.12)] sm:grid-cols-[auto_minmax(0,1fr)]"
      >
        <div className="relative aspect-[3/4] w-full overflow-hidden bg-[var(--parchment)] sm:w-56 md:w-64">
          <img src={deviImageFor(form, settings)} alt={`${form.en} · ${form.deva}`} className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
        </div>
        <div className="flex flex-col justify-center p-7 md:p-10">
          <p className="overline-label text-saffron flex items-center gap-2">
            <Sparkles className="h-3.5 w-3.5" /> {pick(`नवरात्रि · आज दिन ${day}`, `Navratri · Today is Day ${day}`)}
          </p>
          <h2 className={`mt-3 text-3xl text-ink deva-lh md:text-4xl ${isDeva ? "font-deva" : "font-serif-latin"}`}>
            {pick(form.deva, form.en)} <span className="text-ink-3">· {pick(form.en, form.deva)}</span>
          </h2>
          <p className="mt-3 max-w-xl leading-relaxed text-ink-2">{pick(form.sig_hi, form.sig_en)}</p>
          <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-saffron transition-transform group-hover:translate-x-0.5">
            {pick("आज की देवी का दर्शन एवं पूजन", "See today's form & how to worship her")} <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </Link>
    </section>
  );
}
